import React, { useState, useEffect } from 'react'

export const WirwunderLogoWhitener = ({ url }: { url: string }): JSX.Element | null => {
  const [data, setData] = useState<string | undefined>(undefined)
  useEffect(() => {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        setData(text.replace(/#ff0000/gi, '#ffffff'))
      })
      .catch(console.warn)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // TODO: this only runs on mount, verify if this is intended behaviour

  if (!data) return null
  return <div dangerouslySetInnerHTML={{ __html: data }}></div>
}
